import { FinanceResponse } from '@upstart/harmony/lib/legos/financingTypes';
import BackendService from './BackendService';

interface RemoteSigningData {
  email: string;
  phone: string;
  signingLocation: 'STORE_DEVICE' | 'INSTORE_BUYER_DEVICE' | 'REMOTE';
}

type ReviewFinancingPayload = FinanceResponse & {
  remoteSigning?: RemoteSigningData;
  creditPullAttested?: boolean;
};

export default class FinanceResponseService {
  static getForApplications(applicationIds: string[]) {
    return BackendService.post('/financeResponses', {
      body: { applicationIds },
    });
  }

  static get(id: string, params: any): Promise<FinanceResponse> {
    return BackendService.get(`/financeResponses/${id}`, { params });
  }

  static update(financeResponse: FinanceResponse) {
    return BackendService.put(`/financeResponses/${financeResponse.id}`, {
      body: financeResponse,
    });
  }

  static reviewFinancing(
    financeResponse: FinanceResponse,
    remoteSigning?: RemoteSigningData | null,
    creditPullAttested?: boolean | null,
  ) {
    const body: ReviewFinancingPayload = financeResponse;
    if (remoteSigning) {
      body.remoteSigning = remoteSigning;
    }
    if (creditPullAttested !== undefined && creditPullAttested !== null) {
      body.creditPullAttested = creditPullAttested;
    }

    return BackendService.put(
      `/financeResponses/${financeResponse.id}/finance-review`,
      {
        body,
      },
    );
  }

  static async cloneUpstartFinanceResponse(financeResponseId: string) {
    return BackendService.post(`/financeResponses/${financeResponseId}/clone`);
  }
  static getAudit(id: string) {
    return BackendService.get(`/financeResponses/audit/${id}`);
  }
  static getRates(id: string) {
    return BackendService.get(`/financeResponses/${id}/rates`);
  }
}
